import gsap from 'gsap';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default function initQuoteAnimate() {
  const mediaDesktop = window.matchMedia('(min-width: 1024px)');
  const instances = [];

  document.querySelectorAll('[data-quote-animate]').forEach(section => {
    const track = section.querySelector('[data-quote-track]');
    const cards = [...section.querySelectorAll('.quote-card')];
    const dots = section.querySelector('[data-quote-dots]');
    const speed = parseFloat(section.dataset.duration) || 5;

    if (!track || cards.length === 0) return;

    let swiper, marqueeScene;

    function setupSwiper() {
      if (swiper) return;
      swiper = new Swiper(section, {
        modules: [Pagination],
        wrapperClass: 'quote-track',
        slideClass: 'quote-card',
        spaceBetween: 20,
        mousewheel: true,
        pagination: {
          el: dots,
          bulletClass: 'dot',
          bulletActiveClass: 'is-active',
          clickable: true,
          renderBullet(index, className) {
            return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
          },
        },
      });
    }

    function destroySwiper() {
      if (!swiper) return;
      swiper.destroy(true, true);
      swiper = null;
    }

    function setupMarquee() {
      track.querySelectorAll('[data-clone]').forEach(el => el.remove());
      if (marqueeScene) { marqueeScene.kill(); marqueeScene = null; }

      cards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-clone', '');
        track.appendChild(clone);
      });

      gsap.set(track, { yPercent: 0 });
      marqueeScene = gsap.to(track, { yPercent: -50, duration: cards.length * speed, ease: 'none', repeat: -1 });
    }

    function destroyMarquee() {
      if (!marqueeScene) return;
      marqueeScene.kill();
      marqueeScene = null;
      gsap.set(track, { clearProps: 'yPercent' });
      track.querySelectorAll('[data-clone]').forEach(el => el.remove());
    }

    function resizeHandler() {
      if (mediaDesktop.matches) {
        destroySwiper();
        setupMarquee();
      } else {
        destroyMarquee();
        setupSwiper();
      }
    }

    section.addEventListener('mouseenter', () => { if (marqueeScene) marqueeScene.pause(); });
    section.addEventListener('mouseleave', () => { if (marqueeScene) marqueeScene.resume(); });

    instances.push({ resizeHandler });
    resizeHandler();
  });

  mediaDesktop.addEventListener('change', () => {
    instances.forEach(({ resizeHandler }) => resizeHandler());
  });
}
